import { Component, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingService } from '../../service/loading.service';
import { NotificationService } from '../../service/notification.service';
import _ from 'lodash';
import { UtilityService } from '../../service/utility.service';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions, ColDef } from 'ag-grid-community';
import { VendorInvoiceService } from '../../service/vendor-invoice.service';
@Component({
  selector: 'app-purchase-order-history',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AgGridAngular],
  templateUrl: './purchase-order-history.component.html',
  styleUrl: './purchase-order-history.component.css',
})
export class PurchaseOrderHistoryComponent {
  invoices: any[] = [];
  vendorId = JSON.parse(localStorage.getItem('vendorId') || '{}');
  submitted: boolean;
  Activedata: boolean;
  isSearched = false;
  readonly clientId!: string;
  rowData: any[] = [];
  years = [];
  prefixLabel: string = '';

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'normal',
    suppressColumnVirtualisation: true,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Sr',
      valueGetter: (params: any) => {
        return params.node.rowIndex + 1;
      },
      sortable: true,
      filter: true,
      editable: false,
      width: 70,
    },
    {
      headerName: 'PO Number',
      field: 'poNumber',
      sortable: true,
      filter: true,
      editable: true,
    },
    {
      headerName: 'Applicable Fiscal Year',
      field: 'fiscalYear',
      sortable: true,
      filter: true,
      editable: true,
    },
    {
      headerName: 'Total PO Amount',
      field: 'totalpOAmount',
      sortable: true,
      filter: true,
      editable: true,
    },
    {
      headerName: 'Goods and Services Requested',
      field: 'description',
      sortable: true,
      filter: true,
      editable: true,
    },
    {
      headerName: 'DOWNLOAD PO',
      field: 'invoiceStatus',
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        const downloadIcon = document.createElement('i');
        downloadIcon.className = 'fa fa-download download-icon';
        downloadIcon.style.cursor = 'pointer';
        downloadIcon.style.color = 'var(--tg-common-color-blue)';
        downloadIcon.style.transition = 'color 0.3s ease';
        downloadIcon.addEventListener('mouseenter', () => {
          downloadIcon.style.color = 'var(--tg-theme-secondary)';
        });
        downloadIcon.addEventListener('mouseleave', () => {
          downloadIcon.style.color = 'var(--tg-common-color-blue)';
        });
        downloadIcon.addEventListener('click', () => {
          const poData = params.data;
          const poId = poData.id;
          this.ngZone.run(() => {
            this.exportToPdf(poId);
          });
          this.loadingService.OnLoading.emit(true);
        });

        return downloadIcon;
      },
    },
  ];
  defaultColDef = {
    resizable: true,
    flex: 1,
    minWidth: 100,
    floatingFilter: true,
    sortable: true,
    filter: true,
    wrapText: true,
    autoHeight: true,
  };

  constructor(
    private loadingService: LoadingService,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
    private VendorInvoiceService: VendorInvoiceService,
    private ngZone: NgZone,
  ) {}
  onGridReady(params: any) {
    const gridApi = params.api;
    const columnApi = params.columnApi;
    gridApi.sizeColumnsToFit();
  }
  ngOnInit() {
    this.loadingService.OnLoading.emit(true);
    this.VendorInvoiceService.getAllPOs(this.vendorId).subscribe(
      (data: any) => {
        this.rowData = data;
        this.loadingService.OnLoading.emit(false);
      },
      (error: any) => {
        this.loadingService.OnLoading.emit(false);
        this.notificationService.showError(error, 'Error!');
      },
    );
  }

  exportToPdf(poId: string) {
    this.loadingService.OnLoading.emit(true);
    this.VendorInvoiceService.exportToPdf(poId).subscribe(
      (response: any) => {
        this.loadingService.OnLoading.emit(false);
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `purchase-order_${poId}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      },
      (err: any) => {
        this.loadingService.OnLoading.emit(false);
        this.notificationService.showError(err, 'Error!');
      },
    );
  }
}
